import { Box } from "native-base";

export default Box;